export enum ComplexChangeAction {
  Create = 1,
  Archive = 3,
  Restore = 4,
  Price = 1001,
  Composition = 1002,
  Setting = 1003,
}

export type ComplexLastChange = {
  datetime: string
  login: string
  source?: string
  ip?: string
}

export type ComplexHistoryRequestParams = {
  orgId: number | string
  complexId: number | string
  limit?: number
  offset?: number
  actionId?: ComplexChangeAction
  dateFrom?: string | Date
  dateTo?: string | Date
}

export type ComplexHistoryItem = {
  id: string
  operation: string
  date: string
  dateSeconds: number
  oldValue: string
  newValue: string
  user: string
}

export type ComplexHistory = {
  items: Array<ComplexHistoryItem>
  count: number
}

export type CafeteriaComplexWithLastChange = {
  ID: string
  title: string
  position: number
  lastChange?: ComplexLastChange
}
